import { Controller } from "stimulus";

// Bottom-sheet drawers for the mobile student classroom (People + Mural).
export default class extends Controller {
  static targets = ["people", "mural", "muralBadge"];

  openPeople() {
    this.show(this.peopleTarget);
  }

  openMural() {
    this.show(this.muralTarget);
    // clear the unread badge once the Mural is opened
    if (this.hasMuralBadgeTarget) {
      this.muralBadgeTarget.textContent = "0";
      this.muralBadgeTarget.style.display = "none";
    }
  }

  close() {
    if (this.hasPeopleTarget) this.peopleTarget.style.display = "none";
    if (this.hasMuralTarget) this.muralTarget.style.display = "none";
  }

  show(sheet) {
    this.close();
    if (sheet) sheet.style.display = "block";
  }
}
